// extracted by mini-css-extract-plugin
export default {"editInfo":"Edit_editInfo__zSR6X"};